import { changeLogo, setupSignUpForm } from './utils'

jQuery(function ($) {
    setupSignUpForm();

    $('#loginModal').on('shown.bs.modal', function () {
        if($('.user').css('display') === 'none'){
            $('.user').css({'display': 'block'});
            $('.user > a').css({'display': 'none'});
        }
        
        $('#loginModal').modal('show');
        
        changeLogo();

        setupSignUpForm();
    }).on('hidden.bs.modal', function () {
        setupSignUpForm();
    })
})
